import { create } from 'zustand'

interface PageData {
    id: number
    page_number: number
    canvas_json: Record<string, unknown>
    thumbnail_url: string
}

interface ProjectState {
    projectId: string | null
    projectName: string
    documentType: string
    widthMm: number
    heightMm: number
    pages: PageData[]
    status: string
}

interface ProjectActions {
    setProject: (data: {
        id: string
        name: string
        document_type_name: string
        width_mm: number
        height_mm: number
        pages: PageData[]
        status: string
    }) => void
    updatePage: (pageIndex: number, canvasJson: Record<string, unknown>) => void
    addPage: (page: PageData) => void
    removePage: (pageIndex: number) => void
    resetProject: () => void
}

type ProjectStore = ProjectState & ProjectActions

const initialState: ProjectState = {
    projectId: null,
    projectName: '',
    documentType: '',
    widthMm: 210,
    heightMm: 297,
    pages: [],
    status: 'draft',
}

export const useProjectStore = create<ProjectStore>()((set) => ({
    ...initialState,

    setProject: (data) => set({
        projectId: data.id,
        projectName: data.name,
        documentType: data.document_type_name,
        widthMm: data.width_mm,
        heightMm: data.height_mm,
        pages: data.pages,
        status: data.status,
    }),

    updatePage: (pageIndex, canvasJson) => set((state) => {
        const pages = [...state.pages]
        if (pages[pageIndex]) {
            pages[pageIndex] = { ...pages[pageIndex], canvas_json: canvasJson }
        }
        return { pages }
    }),

    addPage: (page) => set((state) => ({
        pages: [...state.pages, page],
    })),

    removePage: (pageIndex) => set((state) => ({
        pages: state.pages.filter((_, i) => i !== pageIndex),
    })),

    resetProject: () => set(initialState),
}))
